const CONSTANTS = {
  HOSTNAME:
    "https://shopping.backend.kudamalana.lk",
};

// @ts-ignore
export default CONSTANTS;
